import React from 'react';

function VisaIcon() {
  return (
    <svg className="brand-chip-icon" viewBox="0 0 48 32" aria-hidden="true">
      <rect width="48" height="32" rx="4" fill="#1A1F71" />
      <path
        fill="#fff"
        d="M19.5 20.5h-2.8l1.7-10.5h2.8L19.5 20.5zm10.2-10.2c-.6-.2-1.5-.5-2.6-.5-2.9 0-4.9 1.5-4.9 3.7 0 1.6 1.5 2.5 2.6 3 1.1.5 1.5.9 1.5 1.3 0 .7-.9 1.1-1.7 1.1-1.1 0-1.7-.2-2.6-.6l-.4-.2-.4 2.4c.7.3 2 .6 3.3.6 3.1 0 5.1-1.5 5.1-3.8 0-1.3-.8-2.2-2.5-3-1-.5-1.6-.8-1.6-1.3 0-.4.5-.9 1.5-.9.9 0 1.5.2 2 .4l.3.1.4-2.3zm7.2-.3h-2.2c-.7 0-1.2.2-1.5.9l-4.2 9.6h2.9l.6-1.6h3.5l.3 1.6h2.6l-2.5-10.5zm-3.8 6.8l1.4-3.9.8 3.9h-2.2zM16.2 10h-2.7l-2.6 10.5h2.6l2.7-10.5z"
      />
    </svg>
  );
}

function MastercardIcon() {
  return (
    <svg className="brand-chip-icon" viewBox="0 0 48 32" aria-hidden="true">
      <rect width="48" height="32" rx="4" fill="#252525" />
      <circle cx="19" cy="16" r="8" fill="#EB001B" />
      <circle cx="29" cy="16" r="8" fill="#F79E1B" />
      <path
        fill="#FF5F00"
        d="M24 10.8a8 8 0 0 0-3.1 6.2A8 8 0 0 0 24 23.2a8 8 0 0 0 3.1-6.2A8 8 0 0 0 24 10.8z"
      />
    </svg>
  );
}

function AmexIcon() {
  return (
    <svg className="brand-chip-icon" viewBox="0 0 48 32" aria-hidden="true">
      <rect width="48" height="32" rx="4" fill="#006FCF" />
      <path
        fill="#fff"
        d="M8.5 21.5V10.5h4.2l1.3 2.8 1.3-2.8h4.2v11h-2.8v-7.2l-1.8 3.7h-1.5l-1.8-3.7v7.2H8.5zm17.2-5.5 2.5 5.5h-3.1l-.5-1.2h-3.3l-.5 1.2h-3.1l3.8-8.5h2.7l3.5 8.5zm-3.9-1.8-1.1-2.6-1.1 2.6h2.2zm8.8 7.3V10.5h5.5c2.4 0 3.9 1.3 3.9 3.4 0 1.5-.8 2.5-2.1 2.9l2.4 4.7h-3.2l-2.1-4.1h-1.2v4.1h-3.2zm3.2-6.3h1.8c.8 0 1.2-.4 1.2-1 0-.6-.4-1-1.2-1h-1.8v2z"
      />
    </svg>
  );
}

function DiscoverIcon() {
  return (
    <svg className="brand-chip-icon" viewBox="0 0 48 32" aria-hidden="true">
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#d1d5db" strokeWidth="1" />
      <rect x="0" y="18" width="48" height="14" rx="0" fill="#F47216" />
      <circle cx="26" cy="14" r="6" fill="#F47216" />
      <path fill="#fff" d="M8 12h3.5c2.2 0 3.5 1.2 3.5 3s-1.3 3-3.5 3H8V12zm3.2 4.5c.9 0 1.4-.5 1.4-1.5s-.5-1.5-1.4-1.5H10.5v3h.7zm8.2-4.5h2.1v6h-2.1v-6zm4.5 0h2.1l2.2 3.8V12h2.1v6h-2.1l-2.2-3.8V18h-2.1v-6z" />
    </svg>
  );
}

export function CardBrandIcon({ brand }) {
  switch (brand) {
    case 'visa':
      return <VisaIcon />;
    case 'mastercard':
      return <MastercardIcon />;
    case 'amex':
      return <AmexIcon />;
    case 'discover':
      return <DiscoverIcon />;
    default:
      return null;
  }
}

export const CARD_BRANDS = [
  { id: 'visa', name: 'Visa' },
  { id: 'mastercard', name: 'Mastercard' },
  { id: 'amex', name: 'Amex' },
  { id: 'discover', name: 'Discover' },
];
